import {
  AuthGuard,
  CustomerAccountAuthGuard,
} from "@redotech/redo-customer-portal-app/contexts/auth";
import { useTranslation } from "@redotech/redo-i18n";
import { breadcrumbSlot, useBreadcrumb } from "@redotech/redo-web/breadcrumb";
import { memo } from "react";
import { Navigate, Outlet, RouteObject } from "react-router-dom";

const homeBreadcrumb = breadcrumbSlot();

const AccountRoot = memo(function AccountRoot() {
  const { t } = useTranslation();
  useBreadcrumb(homeBreadcrumb, t("Home"));

  return (
    <AuthGuard>
      <CustomerAccountAuthGuard>
        <Outlet />
      </CustomerAccountAuthGuard>
    </AuthGuard>
  );
});

export const accountRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: homeBreadcrumb },
    element: <AccountRoot />,
    children: [
      {
        path: "",
        async lazy() {
          const { CustomerAccountTabs } =
            await import("./customer-account-tabs");
          return { Component: CustomerAccountTabs };
        },
        children: [
          { index: true, element: <Navigate replace to="home" /> },
          {
            path: "home",
            async lazy() {
              const { CustomerAccountHome } =
                await import("./home/customer-account-home");
              return { Component: CustomerAccountHome };
            },
          },
          {
            path: "orders",
            async lazy() {
              const { CustomerAccountOrders } =
                await import("./orders/customer-account-orders");
              return { Component: CustomerAccountOrders };
            },
          },
          {
            path: "lists",
            async lazy() {
              const { CustomerAccountList } =
                await import("./lists/customer-account-list");
              return { Component: CustomerAccountList };
            },
          },
          {
            path: "warranties",
            async lazy() {
              const { CustomerAccountWarranties } =
                await import("./warranties/customer-account-warranties");
              return { Component: CustomerAccountWarranties };
            },
          },
          {
            path: "personal-info",
            async lazy() {
              const { CustomerAccountPersonalInfo } =
                await import("./personal-info/customer-account-personal-info");
              return { Component: CustomerAccountPersonalInfo };
            },
          },
        ],
      },
    ],
  },
];
